import React, {useState, useEffect, useCallback} from "react";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, fs } from '../firebase';
import '../css/index.css';
import '../css/Xbar.css';

import XBar from "../elements/Xbar";
import Userpage from "./userpage";
import SyrveMenu from "./SyrveMenu";
import Map from "./map";
import Kinotel from "./kinotel";
import Bar from "../elements/bar";
import ORANGE from "./orange";
import Delivery from "./delivery";
import LoyaltyPage from "./loyaltyPage";
import LandingPage from "./LandingPage";
import { ORDER_MODES, setOrderMode } from '../utils/orderMode';

const companyRouteNames = {
    copacabana: 'CopaCabana',
    aromiitaliani: 'Aromiitaliani',
    symposium: 'Symposium',
    nadimi: 'Nadimi',
    poshnosh: 'PoshNoshs',
    poshnoshs: 'PoshNoshs',
    cave: 'Cave',
};
const itemRoutes = {
    0: '/delivery',
    1: '/locations',
    2: '/menu',
    3: '/profile',
    5: '/kinotel',
    6: '/orange',
    7: '/loyalty',
    8: '/dinein'
};

function Main() {
    const { company } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const loadFromStorage = key => JSON.parse(localStorage.getItem(key)) || false;
    const isHomeRoute = location.pathname === '/' || location.pathname === '/home';

    const getItemFromPath = useCallback(() => {
        if (isHomeRoute) {
            return 9;
        }

        if (company && companyRouteNames[company.toLowerCase()]) {
            return 2;
        }

        if (location.pathname === '/dinein' || location.pathname === '/delivery') {
            return 2;
        }

        const routeEntry = Object.entries(itemRoutes).find(([, route]) => route === location.pathname);
        return routeEntry ? parseInt(routeEntry[0], 10) : 2;
    }, [company, isHomeRoute, location.pathname]);

    const [showServices, setShowServices] = useState(loadFromStorage("showServices"));
    const [showUser, setShowUser] = useState(loadFromStorage("showUser"));
    const [showProducts, setShowProducts] = useState(loadFromStorage("showProducts"));
    const [productPage, setProductPage] = useState(loadFromStorage("productPage"));
    const [showMap, setShowMap] = useState(loadFromStorage("showMap"));
    const [kinotel, setKinotel] = useState(loadFromStorage("showKinotel"));
    const [showLoyaltyPage, setshowLoyaltyPage] = useState(loadFromStorage("showLoyaltyPage"));

    const [activeItem, setActiveItem] = useState(() => {
        if (company && companyRouteNames[company.toLowerCase()]) {
            return 2;
        }
        return getItemFromPath();
    });

    // Check for new users who need onboarding (but don't force it immediately)
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                try {
                    const userDoc = await getDoc(doc(fs, 'users', user.uid));
                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        // If user needs onboarding, just mark them as new
                        // Don't auto-redirect - let them see the prompt on their profile
                        if (userData.isNewUser === true && userData.onboardingCompleted !== true) {
                            localStorage.setItem('isNewUser', 'true');
                        } else {
                            // Clear any stale new user flag
                            localStorage.removeItem('isNewUser');
                        }
                    }
                } catch (error) {
                    console.error('Error checking onboarding status:', error);
                }
            }
        });

        return () => unsubscribe();
    }, [navigate]);


    const handleXBarItemChange = index => {
        console.log("Переключаемся на:", index);
        setActiveItem(index);
        setShowMap(index === 0);
        setShowServices(index === 2);
        setShowUser(index === 3);
        setShowProducts(index === 1);
        setProductPage(index === 5);
        setKinotel(index === 6);
        setshowLoyaltyPage(index===7)
        localStorage.setItem("activeItem", index.toString());

        if (index === 2) {
            const savedCompany = localStorage.getItem('selectedCompany');
            navigate(savedCompany ? `/${savedCompany.toLowerCase()}` : itemRoutes[index]);
            return;
        }

        if (itemRoutes[index] && location.pathname !== itemRoutes[index]) {
            navigate(itemRoutes[index]);
        }
    };



    useEffect(() => {
        const routeCompany = companyRouteNames[company?.toLowerCase()];
        if (routeCompany) {
            localStorage.setItem('selectedCompany', routeCompany);
        }
    }, [company]);

    useEffect(() => {
        if (location.pathname === '/delivery') {
            setOrderMode(ORDER_MODES.DELIVERY);
        }

        if (location.pathname === '/dinein') {
            setOrderMode(ORDER_MODES.DINE_IN);
        }
    }, [location.pathname]);

    useEffect(() => {
        const itemFromPath = getItemFromPath();
        setActiveItem(itemFromPath);
        setShowMap(itemFromPath === 0);
        setShowServices(itemFromPath === 2);
        setShowUser(itemFromPath === 3);
        setShowProducts(itemFromPath === 1);
        setProductPage(itemFromPath === 5);
        setKinotel(itemFromPath === 6);
        setshowLoyaltyPage(itemFromPath === 7);
        localStorage.setItem("activeItem", itemFromPath.toString());
    }, [getItemFromPath]);
    
    useEffect(() => {
        console.log("showLoyaltyPage:", showLoyaltyPage);
        localStorage.setItem("showServices", JSON.stringify(showServices));
        localStorage.setItem("showUser", JSON.stringify(showUser));
        localStorage.setItem("showKinotel", JSON.stringify(kinotel));
        localStorage.setItem("showProducts", JSON.stringify(showProducts));
        localStorage.setItem("productPage", JSON.stringify(productPage));
        localStorage.setItem("showMap", JSON.stringify(showMap));
        localStorage.setItem("showLoyaltyPage", JSON.stringify(showLoyaltyPage));
    }, [showServices, showUser, showProducts, productPage, showMap, kinotel,showLoyaltyPage]);


    return (
        <div className="">

            <Bar/>


            {isHomeRoute && <LandingPage />}
            {showUser && <Userpage handleXBarItemChange={handleXBarItemChange}/>}
            {showLoyaltyPage && <LoyaltyPage handleXBarItemChange={handleXBarItemChange}/>}
            {showMap && <Delivery />}
            {showServices && <SyrveMenu handleXBarItemChange={handleXBarItemChange}/>}

            {showProducts && <Map handleXBarItemChange={handleXBarItemChange}/>}
            {productPage && <Kinotel handleXBarItemChange={handleXBarItemChange}/>}
            {kinotel && <ORANGE handleXBarItemChange={handleXBarItemChange}/>}


            <XBar activeItem={activeItem} onItemClick={handleXBarItemChange}/>
        </div>
    );
}

export default Main;
